import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Card, Col, DatePicker, Row, Space, Statistic, Table, Tag, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { api } from '@/lib/api';
import { formatRupiah } from '@/lib/format';
const RESTRICTION_LABEL = {
    UNRESTRICTED: 'Tanpa Pembatasan',
    TEMP_RESTRICTED: 'Terikat Sementara',
    PERM_RESTRICTED: 'Terikat Permanen',
};
const RESTRICTION_COLOR = {
    UNRESTRICTED: 'green',
    TEMP_RESTRICTED: 'gold',
    PERM_RESTRICTED: 'purple',
};
const lineCols = [
    { title: 'Kode', dataIndex: 'code', width: 120 },
    { title: 'Nama', dataIndex: 'name' },
    {
        title: 'Restriksi',
        dataIndex: 'restriction',
        width: 160,
        render: (v) => _jsx(Tag, { color: RESTRICTION_COLOR[v], children: RESTRICTION_LABEL[v] ?? v }),
    },
    {
        title: 'Jumlah',
        dataIndex: 'amount',
        width: 180,
        align: 'right',
        render: (v) => _jsx("b", { children: formatRupiah(v) }),
    },
];
export function ActivityStatementPage() {
    const [range, setRange] = useState([dayjs().startOf('month'), dayjs()]);
    const q = useQuery({
        queryKey: ['activity', range[0].format('YYYY-MM-DD'), range[1].format('YYYY-MM-DD')],
        queryFn: async () => (await api.get('/reports/activity', {
            params: {
                from: range[0].format('YYYY-MM-DD'),
                to: range[1].format('YYYY-MM-DD'),
            },
        })).data,
    });
    const restrictionCols = [
        {
            title: 'Restriksi',
            dataIndex: 'restriction',
            render: (v) => _jsx(Tag, { color: RESTRICTION_COLOR[v], children: RESTRICTION_LABEL[v] ?? v }),
        },
        {
            title: 'Pendapatan',
            dataIndex: 'revenue',
            align: 'right',
            render: (v) => formatRupiah(v),
        },
        {
            title: 'Beban',
            dataIndex: 'expense',
            align: 'right',
            render: (v) => formatRupiah(v),
        },
        {
            title: 'Surplus / Defisit',
            dataIndex: 'surplus_deficit',
            align: 'right',
            render: (v) => (_jsx("b", { style: { color: parseFloat(v) >= 0 ? '#059669' : '#DC2626' }, children: formatRupiah(v) })),
        },
    ];
    return (_jsxs("div", { children: [_jsxs(Space, { style: { marginBottom: 16, display: 'flex', justifyContent: 'space-between' }, children: [_jsx(Typography.Title, { level: 3, style: { margin: 0 }, children: "Laporan Aktivitas" }), _jsx(DatePicker.RangePicker, { value: range, onChange: (v) => v && v[0] && v[1] && setRange([v[0], v[1]]) })] }), _jsxs(Row, { gutter: 16, style: { marginBottom: 16 }, children: [_jsx(Col, { span: 8, children: _jsx(Card, { children: _jsx(Statistic, { title: "Total Pendapatan", value: parseFloat(q.data?.total_revenue ?? '0'), formatter: (v) => formatRupiah(Number(v)), valueStyle: { color: '#059669' } }) }) }), _jsx(Col, { span: 8, children: _jsx(Card, { children: _jsx(Statistic, { title: "Total Beban", value: parseFloat(q.data?.total_expense ?? '0'), formatter: (v) => formatRupiah(Number(v)), valueStyle: { color: '#DC2626' } }) }) }), _jsx(Col, { span: 8, children: _jsx(Card, { children: _jsx(Statistic, { title: "Perubahan Aset Bersih", value: parseFloat(q.data?.change_in_net_assets ?? '0'), formatter: (v) => formatRupiah(Number(v)), valueStyle: {
                                    color: parseFloat(q.data?.change_in_net_assets ?? '0') >= 0 ? '#059669' : '#DC2626',
                                } }) }) })] }), _jsx(Card, { title: "Ringkasan per Restriksi Dana", size: "small", style: { marginBottom: 16 }, children: _jsx(Table, { rowKey: "restriction", size: "small", pagination: false, loading: q.isLoading, columns: restrictionCols, dataSource: q.data?.by_restriction ?? [] }) }), _jsx(Card, { title: "Pendapatan", size: "small", style: { marginBottom: 16 }, children: _jsx(Table, { rowKey: (r) => `${r.code}-${r.restriction}`, size: "small", pagination: false, loading: q.isLoading, columns: lineCols, dataSource: q.data?.revenues ?? [] }) }), _jsx(Card, { title: "Beban", size: "small", children: _jsx(Table, { rowKey: (r) => `${r.code}-${r.restriction}`, size: "small", pagination: false, loading: q.isLoading, columns: lineCols, dataSource: q.data?.expenses ?? [] }) })] }));
}
